import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import homeTranslations from "../i18n/homeTranslations";

export default function Home({ forcedLang }) {
  // Lógica de Idioma + fallbacks
  const raw =
    forcedLang ||
    localStorage.getItem("kitoLang") ||
    (navigator.language || "pt").slice(0, 2);
  const lang = ["pt", "en", "es"].includes(raw) ? raw : "pt";
  const t = homeTranslations[lang] || homeTranslations.pt;

  // Helper para badges das lojas por idioma
  const badgeByLang = (base) => {
    const map = {
      pt: `https://storage.googleapis.com/kito-mobile-app.firebasestorage.app/site-images/${base}-pt.svg`,
      es: `https://storage.googleapis.com/kito-mobile-app.firebasestorage.app/site-images/${base}-en.svg`,
      en: `https://storage.googleapis.com/kito-mobile-app.firebasestorage.app/site-images/${base}-en.svg`,
    };
    return map[lang] || map.en;
  };

  // Labels de Acessibilidade e Status
  const a11y = {
    googlePlay: t.a11y?.googlePlay || "Google Play",
    appStore: t.a11y?.appStore || "App Store",
  };

  const statusFuture = {
    pt: "Em desenvolvimento",
    en: "Under development",
    es: "En desarrollo",
  }[lang];

  const gamesDescription = {
    pt: "Jogos interativos e educativos com a Turma do Kito. Diversão garantida em breve!",
    en: "Interactive and educational games with Kito and friends. Coming soon!",
    es: "Juegos interactivos y educativos con Kito y sus amigos. ¡Próximamente!",
  }[lang];

  const heroImageText = {
    pt: "Histórias, imaginação e leitura para crianças e famílias.",
    en: "Stories, imagination, and reading for children and families.",
    es: "Historias, imaginación y lectura para niños y familias.",
  }[lang];

  return (
    <main className="home">
      <section className="home-hero">
        <div className="home-hero-content">
          <span className="home-eyebrow">{t.heroEyebrow}</span>
          <h1 className="home-hero-title">{t.heroTitle}</h1>
          <p className="home-hero-subtitle">{t.heroSubtitle}</p>
          <div className="home-hero-actions">
            <a href="#download" className="btn-primary">{t.heroCtaPrimary}</a>
            <a href="#parceria" className="btn-ghost">{t.heroCtaSecondary}</a>
          </div>
        </div>
        <div className="home-hero-media">
          <img
            className="home-hero-media-bg"
            src="/images/capa-loja.png"
            alt=""
            loading="lazy"
          />
          <div className="home-hero-media-overlay" />
          <div className="home-hero-copy">
            <span className="home-hero-copy-badge">Kito</span>
            <p>{heroImageText}</p>
          </div>
          <div className="home-hero-badge">{t.heroBadge}</div>
        </div>
      </section>

      <section className="home-section">
        <div className="home-section-header">
          <h2>{t.standard?.title}</h2>
          <p>{t.standard?.subtitle}</p>
        </div>
        <div className="home-plan-row">
          {(t.standard?.plans || []).map((plan, index) => (
            <span key={index} className="home-plan-pill">{plan}</span>
          ))}
        </div>
        <div className="home-grid">
          {(t.standard?.cards || []).map((card, index) => (
            <article key={index} className="home-card home-card-standard">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
        <div className="home-feature-block">
          <div className="home-section-header home-section-header-compact">
            <h3>{t.features?.title}</h3>
            <p>{t.features?.subtitle}</p>
          </div>
          <div className="home-feature-grid">
            {(t.features?.items || []).map((item, index) => (
              <div key={index} className="home-feature">{item}</div>
            ))}
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="home-section-header">
          <h2>{t.activities?.title}</h2>
          <p>{t.activities?.subtitle}</p>
        </div>
        <div className="home-activity-badge">{t.activities?.badge}</div>
        <div className="home-grid">
          {(t.activities?.cards || []).map((card, index) => (
            <article key={index} className="home-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <ul>
                {(card.items || []).map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section id="parceria" className="home-partner">
        <div className="home-partner-card">
          <div className="home-partner-copy">
            <a
              className="home-partner-logo"
              href={t.partner?.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Acessar ambiente Acuidar"
            >
              <img src="/images/acuidar-logo.webp" alt="Acuidar" />
            </a>
            <div>
              <span className="home-eyebrow">{t.partner?.eyebrow}</span>
              <h2>{t.partner?.title}</h2>
              <p>{t.partner?.description}</p>
              <div className="home-partner-label">{t.partner?.whiteLabelLabel}</div>
              <p className="home-partner-whitelabel">{t.partner?.whiteLabelDescription}</p>
              <a
                className="home-partner-link"
                href={t.partner?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.partner?.ctaLabel}
              </a>
              <a
                className="home-partner-link home-partner-link-secondary"
                href={t.partner?.secondaryUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t.partner?.secondaryCtaLabel}
              </a>
              <Link className="home-partner-internal-cta" to="/white-label">
                {t.partner?.internalCtaLabel || "Sua marca no Kito"}
              </Link>
            </div>
          </div>
          <div className="home-partner-showcase">
            <article className="home-partner-screen">
              <span className="home-partner-screen-label">{t.partner?.defaultLabel}</span>
              <div className="home-partner-screen-frame">
                <img
                  src="/images/print-kito.png"
                  alt="Tela de login padrão do Kito"
                  loading="lazy"
                  width="240"
                  height="520"
                />
              </div>
            </article>
            <article className="home-partner-screen">
              <span className="home-partner-screen-label">{t.partner?.whitelabelLabel}</span>
              <div className="home-partner-screen-frame">
                <img
                  src="/images/print-acuidar.png"
                  alt="Tela de login white-label da Acuidar"
                  loading="lazy"
                  width="240"
                  height="520"
                />
              </div>
            </article>
          </div>
        </div>
      </section>

      <section id="download" className="home-section home-download">
        <div className="home-section-header">
          <h2>{t.download?.title}</h2>
          <p>{t.download?.subtitle}</p>
        </div>
        <div className="home-store">
          <a
            href="/download"
            aria-label={a11y.googlePlay}
          >
            <img
              src={badgeByLang("google-play")}
              alt={a11y.googlePlay}
              loading="lazy"
              width="150"
              height="44"
            />
          </a>
          <a
            href="/download"
            aria-label={a11y.appStore}
          >
            <img
              src={badgeByLang("app-store")}
              alt={a11y.appStore}
              loading="lazy"
              width="150"
              height="44"
            />
          </a>
        </div>
        <div className="home-ecosystem">
          <div className="home-ecosystem-item">
            <h3 className="home-ecosystem-title">
              <img
                src="/images/kito.png"
                alt="Kito App"
                loading="lazy"
                width="28"
                height="28"
              />
              <span>Kito App</span>
            </h3>
            <p>{t.card.kito?.description}</p>
          </div>
          <div className="home-ecosystem-item">
            <h3 className="home-ecosystem-title">
              <img
                src="/images/kito-games.png"
                alt="Kito Games"
                loading="lazy"
                width="28"
                height="28"
              />
              <span>Kito Games</span>
            </h3>
            <p>{gamesDescription}</p>
            <span className="home-status">{statusFuture}</span>
          </div>
        </div>
      </section>
    </main>
  );
}
